type WorkplaceArchiveFlag = {
  archivedAt?: string | Date | null;
};

export function excludeArchivedWorkplaces<T>(workplaces: readonly T[]): T[] {
  return workplaces.filter((workplace) => {
    if (workplace == null || typeof workplace !== "object") {
      return true;
    }

    const archivedAt = (workplace as WorkplaceArchiveFlag).archivedAt;
    return archivedAt == null;
  });
}
